import RecallIcon from "../../icons/Recall";
import StarBorderIcon from "../../icons/StarBorder";
import LockIcon from "../../icons/Lock";
import PreOrderIcon from "../../icons/PreOrder";
import ReportProblemIcon from "../../icons/ReportProblem";
import { PriorityConfig } from "./types";

export const priorityStockFlags = {
	recall: "Recall",
	newRelease: "New Release",
	embargo: "Embargo",
	preOrder: "Pre-Order",
	highPriority: "High Priority",
	display: "Display",
};
export const priorityStockFlagsArray = [
	priorityStockFlags.recall,
	priorityStockFlags.newRelease,
	priorityStockFlags.embargo,
	priorityStockFlags.preOrder,
	priorityStockFlags.highPriority,
	priorityStockFlags.display,
];
export const PRIORITY_STOCK_FLAG_CONFIG: Record<string, PriorityConfig> = {
	[priorityStockFlags.recall]: {
		priorityClassName: "recallTag",
		Icon: RecallIcon,
		iconProps: { white: true },
	},
	[priorityStockFlags.newRelease]: {
		priorityClassName: "newReleaseTag",
		Icon: StarBorderIcon,
		iconProps: { white: true },
	},
	[priorityStockFlags.embargo]: {
		priorityClassName: "embargoTag",
		Icon: LockIcon,
		iconProps: { white: true },
	},
	[priorityStockFlags.preOrder]: {
		priorityClassName: "preOrderTag",
		Icon: PreOrderIcon,
		iconProps: { white: false },
	},
	[priorityStockFlags.highPriority]: {
		priorityClassName: "highPriorityTag",
		Icon: ReportProblemIcon,
		iconProps: { white: true },
	},
};
